import PanelActionFooter from 'pages/MaintenancePage/components/PanelActionFooter';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import {
    CANCEL_BUTTON_TEST_ID,
    KEEP_BUTTON_TEST_ID,
    RETURN_BUTTON_TEST_ID,
    TEST_ID
} from './constants';
import type { FunctionComponent, HeldReadiness, Props } from './types';

// Pure config over the shared PanelActionFooter — the secondary slot carries the
// keep-current-status action, the primary confirms the return to service.
const ReturnToServiceFooter: FunctionComponent<Props> = ({
    className = '',
    onCancel,
    onKeepStatus,
    onReturnToService,
    readiness,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const keepLabels: Record<HeldReadiness, string> = {
        grounded: t.RETURN_TO_SERVICE_KEEP_GROUNDED,
        hold: t.RETURN_TO_SERVICE_KEEP_HOLD
    };

    return (
        <PanelActionFooter
            cancelTestId={CANCEL_BUTTON_TEST_ID}
            cancelText={t.LOG_SERVICE_CANCEL}
            className={className}
            onCancel={onCancel}
            onPrimary={onReturnToService}
            onSecondary={onKeepStatus}
            primaryTestId={RETURN_BUTTON_TEST_ID}
            primaryText={t.RETURN_TO_SERVICE_RETURN}
            secondaryTestId={KEEP_BUTTON_TEST_ID}
            secondaryText={keepLabels[readiness]}
            testId={testId}
        />
    );
};

export default ReturnToServiceFooter;
